import FETCH_INTERNAL_REFERRALS from './queries/fetch-internal-referrals.js';
import getClientInstance from '../../../app/config/apollo-client';
import { get, isNull } from 'lodash';

function buildCreatedByValue(referral) {
  const firstName = get(referral, 'createdByPerson.firstNm', null);
  const lastName = get(referral, 'createdByPerson.lastNm', null);

  if (isNull(firstName) || isNull(lastName)) { return '' }

  return `${firstName} ${lastName}`;
}

function formatReferrals(referrals) {
  return referrals.map(referral => {
    return {
      referralId: get(referral, 'id'),
      statusCode: get(referral, 'referralStatusCode'),
      serviceName: get(referral, 'refServiceSpecialty.displayName'),
      referringProvider: get(referral, 'referredBy.fullName'),
      referralDate: get(referral, 'serviceReferralDate'),
      consultDate: get(referral, 'resultingConsult.actualStartDate'),
      createdBy: buildCreatedByValue(referral),
      consultId: get(referral, 'resultingConsult.id'),
    }
  })
}

const getInternalReferrals = (memberId) => {
  const apolloClient = getClientInstance();

  return apolloClient
    .query({
      variables: { id: memberId },
      query: FETCH_INTERNAL_REFERRALS,
      fetchPolicy: 'no-cache'
    })
    .then(result => {
      const referrals = get(result, 'data.member.providerReferrals');

      return {
        referrals: formatReferrals(referrals)
      };

    })
    .catch(e => {
      console.error(e);

      return { referrals: [], error: 'Failed to get internal referrals' };
    });
}

export default getInternalReferrals;
